"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var UseAcTableData_1 = require("../table/UseAcTableData");
var AcGrid_module_scss_1 = __importDefault(require("./AcGrid.module.scss"));
exports.AcGrid = function (props) {
    var column = props.column, functionContext = props.functionContext, data = props.data, loading = props.loading;
    var containerEl = react_1.useRef(null);
    var _a = UseAcTableData_1.useAcTableData({
        columns: [column],
        data: data,
        functionContext: functionContext,
    }), acTableColumns = _a.acTableColumns, acTableItems = _a.acTableItems, setData = _a.setData;
    react_1.useEffect(function () {
        setData(data || []);
    }, [data]);
    var history = react_router_dom_1.useHistory();
    var createItem = function (acTableColumn, index, acTableItem) {
        if (acTableColumn.data) {
            var value = acTableColumn.buildValue(acTableItem.data, functionContext);
            var linkWrapper = function (el) {
                return react_1.default.createElement(react_1.default.Fragment, null, el);
            };
            if (acTableColumn.hasPath()) {
                var path_1 = acTableColumn.buildPath(acTableItem.data);
                var onClick_1 = function () {
                    history.push(path_1);
                };
                linkWrapper = function (el) { return (react_1.default.createElement("a", { href: "javascript:void(0);", onClick: onClick_1 }, el)); };
            }
            return react_1.default.createElement(react_1.default.Fragment, null, linkWrapper(value));
        }
    };
    var items = acTableItems.map(function (acTableItem, index) {
        var acTableColumn = acTableColumns[0];
        return createItem(acTableColumn, index, acTableItem);
    });
    return (react_1.default.createElement("div", { ref: containerEl, className: "d-flex flex-wrap mb-2" }, loading ? (react_1.default.createElement("div", { className: AcGrid_module_scss_1.default.gridLoadingOverlay },
        react_1.default.createElement("div", { style: { height: '64px' }, className: "rounded shadow p-4 d-flex m-auto bg-white" },
            react_1.default.createElement("i", { className: "fas fa-2x fa-spin fa-spinner text-cloudLink" })))) : (items === null || items === void 0 ? void 0 : items.length) ? (items) : (react_1.default.createElement("p", { className: "fs-18 font-weight-bold m-auto" }, "\u8868\u793A\u3067\u304D\u308B\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093"))));
};
exports.AcGrid.displayName = 'AcGrid';
//# sourceMappingURL=AcGrid.js.map